module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "top": "0px",
      "height": "50px",
      "width": "100%",
      "background-color": "blue",
      "color": "#fff"
    }
  }, [_c('header', {
    staticClass: "main-header"
  }, [_c('a', {
    staticClass: "logo",
    staticStyle: {
      "padding": "0px"
    },
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-bars sidebar-toggle",
    staticStyle: {
      "float": "left",
      "padding-top": "10px",
      "font-size": "30px",
      "font-weight": "100"
    },
    attrs: {
      "data-toggle": "push-menu",
      "role": "button"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "height": "50px",
      "float": "left"
    },
    attrs: {
      "src": require("../static/img/logo-small.png"),
      "alt": "Printer Counters"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "16px",
      "float": "right",
      "padding-right": "5px"
    }
  }, [_vm._v("V. " + _vm._s(_vm.$root.version))]), _vm._v(" "), (_vm.$root.hasNewVersion) ? _c('span', {
    staticClass: "label label-danger",
    on: {
      "click": function($event) {
        return _vm.$root.confirmRefresh()
      }
    }
  }, [_vm._v("1")]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1d6cc566!./~/vue-loader/lib/selector.js?type=template&index=0!./src/NaviMobile.vue
// module id = 677
// module chunks = 0